const elocaRoutes = [
  {
    path: '/eloca/servicos',
    name: 'eloca.servicos',
    component: () => import('../views/eloca/Servicos.vue'),
  },
  {
    path: '/eloca/store',
    name: 'eloca.store',
    component: () => import('../views/eloca/Store.vue'),
  },
];

export default elocaRoutes;
